var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-style"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12",staticStyle:{"height":"100%"}},[_c('FormLogin',{staticClass:"mx-auto bg-white shadow rounded p-12"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }